<script setup lang="ts">
import Message from 'primevue/message'

interface Props {
  daysRemaining: number
}

const props = defineProps<Props>()
const { t } = useI18n()

const severityClass = computed(() => {
  if (props.daysRemaining <= 2) return 'error'
  if (props.daysRemaining <= 4) return 'warn'
  return 'warn'
})

const messageText = computed(() => {
  if (props.daysRemaining === 0) {
    return t('Payment overdue - Service will be paused soon')
  }
  if (props.daysRemaining === 1) {
    return t('Payment due - Service will be paused in 1 day')
  }
  return t('Payment due - Service will be paused in {days} days', { days: props.daysRemaining })
})
</script>

<template>
  <div class="sticky top-0 z-50 w-full">
    <Message
      :severity="severityClass"
      :closable="false"
      class="m-0 rounded-none border-x-0 border-t-0"
    >
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-3">
          <Icon
            name="pi pi-exclamation-triangle"
            class="text-xl"
          />
          <span class="font-semibold">
            {{ messageText }}
          </span>
        </div>
        <div class="text-sm">
          {{ t('Please contact support to process your payment') }}
        </div>
      </div>
    </Message>
  </div>
</template>

<style scoped>
/* Ensure banner is always visible and not affected by layout */
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
</style>
